import React from 'react';
import { Link } from 'react-router-dom';
import img from '../../../images/NextProject.png'

const NextJsProject = () => {
    return (
        <div className="popular-projects">
        <div className="popular-project-head-div">
          <div data-aos="zoom-out" className="row  com-a">
            <div data-aos="fade-up" className="col-md-5 com-b">
              <img
                class="popular-projects-img"
                src={img}
                alt="home page"
              />
            </div>
            <div className="col-md-6 com-b">
              <h3 data-aos="slide-down">
                RONDHAN
              </h3>
              <div data-aos="slide-up">
                <p>
                Rondhan is a Agriculture based website, it will become a farmer management system, my responsnsibilty in frontend.

                </p>
                <p>
                Technologies: NextJs, React Bootstrap, REST Api, Vercel.

                </p>
                <p>
                Using Server Side Rendering(SSR), SSG all device responsive UI.

                </p>
                <p>This website help our Agriculture sector, farmer can farming with proper knowledge, support and equipment </p>
              </div>
              <Link className="aboutMe-button" to="/Rondhan">
                <b>More Details</b>
              </Link>
              <a
                target="_blank"
                className="resume"
                href="https://rondhan.vercel.app/"
              >
                <b>Live Site</b>
              </a>
            </div>
          </div>
        </div>
      </div>
    );
};

export default NextJsProject;